import { render, staticRenderFns } from "./AddSession.vue?vue&type=template&id=5b508829&"
import script from "./AddSession.vue?vue&type=script&lang=js&"
export * from "./AddSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports